/**
 * Route: /speedtest — Story 5.5 (Speedtests Ergebnis-Monitor)
 *
 * Ersetzt den Platzhalter aus Story 0.2 durch den echten Passiv-Monitor.
 * Referenz: claude-design-import/speedtest.html. Die Route-ID bleibt
 * unverändert (Sidebar-Eintrag "Speedtest", Tag "Mobile").
 */
import { createFileRoute } from '@tanstack/react-router'
import { SpeedtestMonitorPage } from '../features/speedtest/SpeedtestMonitorPage'

export const Route = createFileRoute('/_auth/speedtest')({
  component: SpeedtestMonitorPage,
})
